export const CustomHeader = [
  {
    label: "X-Rsys-Caller-Language",
    value: "X-Rsys-Caller-Language",
  },
  {
    label: "X-Rsys-Callee-Language",
    value: "X-Rsys-Callee-Language",
  },
  {
    label: "X-Rsys-Caller-Gender",
    value: "X-Rsys-Caller-Gender",
  },
  {
    label: "X-Rsys-Callee-Gender",
    value: "X-Rsys-Callee-Gender",
  },
  {
    label: "X-Rsys-RoomID",
    value: "X-Rsys-RoomID",
  },
];

export const Gender = [
  {
    label: "Male",
    value: "Male",
  },
  {
    label: "Female",
    value: "Female",
  },
];

export const Language = [
  {
    label: "English",
    value: "English",
  },
  {
    label: "Hindi",
    value: "Hindi",
  },
]
